import React from 'react'

const Time = ({ dados, handleInputChange }) => {
    const inputId = `time-${dados.name?.replace(/\s+/g, '-').toLowerCase()}`;
    
    return (
        <div className="flex flex-col space-y-1">
            {dados.titulo && (
                <label 
                    htmlFor={inputId}
                    className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                >
                    {dados.titulo}
                    {dados.required && <span className="text-red-500 ml-1" aria-label="campo obrigatório">*</span>}
                </label>
            )}
            <input
                id={inputId}
                type="time"
                name={dados.name}
                value={dados.valor || ''}
                onChange={handleInputChange}
                disabled={dados.disabled}
                required={dados.required}
                className="w-full px-4 py-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:border-vox-green-500 transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
            />
        </div>
    )
}

export default Time
